export default {
  readMoreIntro: {
    id: 'hub_buying_guide_read_more_intro',
    defaultMessage: 'Read more',
  },
  featuredTitle: {
    id: 'hub_buying_guide_featured_title',
    defaultMessage: 'Most popular articles',
  },
}
